module.exports = __webpack_public_path__ + "static/media/hospital-visit.f12656fd.svg";